import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  Filler,
  Tooltip
} from 'chart.js'

Chart.register(CategoryScale, LinearScale, PointElement, LineElement, LineController, Filler, Tooltip)

export default {
  name: 'AreaChart',
  props: {
    chartData: { type: Object, required: true },
    options: { type: Object, default: () => ({}) },
    animate: { type: Boolean, default: true }
  },
  render(h) {
    return h('div', { style: { position: 'relative', width: '100%', height: '100%' } }, [
      h('canvas', { ref: 'canvas' })
    ])
  },
  data() {
    return { chart: null }
  },
  mounted() {
    this.createChart()
  },
  methods: {
    createChart() {
      if (this.chart) this.chart.destroy()
      var ctx = this.$refs.canvas.getContext('2d')
      var gradientCaches = {}
      var cachedHeight = 0
      this.chart = new Chart(ctx, {
        type: 'line',
        data: this.chartData,
        options: this.options,
        plugins: [{
          beforeDatasetsDraw: function(chart) {
            var area = chart.chartArea
            if (!area) return
            var height = area.bottom - area.top
            if (height !== cachedHeight) {
              gradientCaches = {}
              cachedHeight = height
            }
            chart.data.datasets.forEach(function(ds) {
              if (ds.fill === false) return
              var stops = ds._gradientStops
              if (!stops) {
                stops = ['rgba(201, 168, 76, 0.35)', 'rgba(201, 168, 76, 0.02)']
              }
              var key = stops[0] + stops[1]
              if (!gradientCaches[key]) {
                var g = chart.ctx.createLinearGradient(0, area.top, 0, area.bottom)
                g.addColorStop(0, stops[0])
                g.addColorStop(1, stops[1])
                gradientCaches[key] = g
              }
              ds.backgroundColor = gradientCaches[key]
            })
          }
        }]
      })
    }
  },
  watch: {
    chartData: {
      handler(newData) {
        if (this.chart) {
          this.chart.data = newData
          this.chart.update(this.animate ? undefined : 'none')
        } else {
          this.createChart()
        }
      },
      deep: true
    },
    options: {
      handler() {
        if (this.chart) {
          this.chart.options = this.options
          this.chart.update()
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
